//import civs from '../config/civs.json'
import draftOptions from '../config/draftOptions.json'
import classNames from 'classnames';
import { useQuery } from "react-query";
import { useId, useState, useEffect } from 'react'


export function CivSelector({ civ, state, leftSide, allowEmpty, onChange, index, showDraftOptions = false, sniped = false, onChangeDraftOption, key }) {

	const id = useId()

	const [selectedValue, setSelectedValue] = useState(civ || '');

	const fetchCivs = async () => {
		const res = await fetch(`${window.__RUNTIME_CONFIG__.REACT_APP_BACKEND_URL}/api/config/civs`);
		return res.json();
	};

	const { data } = useQuery("civs", fetchCivs);

	// keep local selectedValue in sync when incoming props or data change
	useEffect(() => {
		if (data) {
			const found = data.find((value) => value.aoe2cm === civ || value.label === civ);
			// prefer matching aoe2cm if possible, otherwise fall back to civ prop
			setSelectedValue(found?.aoe2cm || civ || '');
		} else {
			setSelectedValue(civ || '');
		}
	}, [civ, data]);

	const selectedCiv = data?.find((value) => value.aoe2cm === selectedValue || value.label === selectedValue) || data?.find((value) => value.aoe2cm === civ || value.label === civ);

	function handleChange(el) {
		const val = el.target.value;
		setSelectedValue(val);
		let side = leftSide ? 'host' : 'guest'
		if (onChange)
			onChange(val, index, side);
	}

	function handleChangeDraftOption(el) {
		let side = leftSide ? 'host' : 'guest'
		if (onChange)
			onChange(el.target.value, index, side, 'action');
	}

	const randomFlag = '/civFlags/random.png';
	return (
		<div className={classNames('flex', !!leftSide ? 'flex-row' : 'flex-row-reverse')}>
			{data && <>
				<img className='w-12 h-8' src={selectedCiv?.originalFlag || randomFlag} />
				{sniped &&
					<img className='w-10 h-10 absolute -mt-1 mx-1' src='/civSniped.png'/>
				}

				<select value={selectedValue} onChange={handleChange} className={classNames('border-solid border-[0.5px] h-8', (state === "ban" || state === "snipe") && "bg-red-200", state === "pick" && "bg-green-200")}>
					{allowEmpty && <option value=''> (unknown) </option>}
					{data.sort((a, b) => a.label.localeCompare(b.label)).map(_civ =>
						<option key={`${id}_${_civ.aoe2cm}`} id={`${id}_${_civ.aoe2cm}`} value={_civ.aoe2cm}>{_civ.label}</option>
					)}
				</select>

				{(state || showDraftOptions) && <select value={state} onChange={handleChangeDraftOption} className='border-solid border-zinc-600 border-[0.5px] h-8 w-16'>{draftOptions.map(option => <option value={option}>{option}</option>)}</select>}
			</>
			}
		</div>
	)
}
